import React, { createContext, useContext } from "react";
import { IProjectStage, ISortProject } from "./_models";

// The project and stage loaded by ManageProjectStage, shared with the stage screens.
type ProjectStageContextType = {
  project: ISortProject;
  stage: IProjectStage;
  stages: IProjectStage[];
};

const ProjectStageContext = createContext<ProjectStageContextType | undefined>(undefined);

export const ProjectStageProvider: React.FC<ProjectStageContextType & { children: React.ReactNode }> = ({ project, stage, stages, children }) => (
  <ProjectStageContext.Provider value={{ project, stage, stages }}>
    {children}
  </ProjectStageContext.Provider>
);

export function useProjectStage(): ProjectStageContextType {
  const context = useContext(ProjectStageContext);
  if (!context) {
    throw new Error("useProjectStage must be used within a ProjectStageProvider");
  }
  return context;
}
